export default __webpack_public_path__ + "images/979d057e4619d9b6133e0824f5549683.svg";